import {
    isValidElement,
    Children,
    type FC
} from "react";
import {
    View
} from "react-native";
import type IBreadcrumbItemProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useBreadcrumbItemContext,
    useBreadcrumbContext
} from "../../context";
import BreadcrumbSeparator from "../separator";

const BreadcrumbItem: FC<IBreadcrumbItemProps> = ({
    customTheme: customThemeProp,
    children,
    style,
    ...props
}) => {
    const context = useBreadcrumbContext();

    const itemContext = useBreadcrumbItemContext();

    const {
        spaces
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context.customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    const hasCustomSeparator = Children.toArray(children).some((node) => isValidElement(node) && node.type === BreadcrumbSeparator);

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            itemContext.isLast && stylesheet.last,
            containerDynamicStyle
        ]}
        role="listitem"
    >
        {
            hasCustomSeparator ?
                null
            :
                <BreadcrumbSeparator
                    customTheme={customThemeProp}
                />
        }
        {children}
    </View>;
};
export default BreadcrumbItem;
